module.exports = __webpack_public_path__ + "media/Video 17.835fe679.mp4";